import React from "react";
// import classes from "./RoundedButton.module.scss";
import parentClasses from "../Buttons.module.scss";
import * as btnConfig from "../../../constants/buttons";
import { getIcon } from "../../../helpers/uiHelpers";

const RoundedButton = ({
  className = "",
  type = "button",
  rounded = null,
  disable = null,
  onClick = () => {},
  text = null,
  icon = null,
  btnType = null,
  size = null,
  alt = null,
  title = null,
}) => {
  /**
   * Setting button content
   */
  // inner _text
  const _btnRoundedClass = rounded ? parentClasses.Rounded : "";
  const _text = text ? (
    <span className={parentClasses.Text}>{icon}{text}</span>
  ) : null;
  // const _icon = getIcon(icon, parentClasses.Icon);

  /**
   * Setting button parentClasses
   */
  // Check if is rounded
  // Check the button type (style of the button)
  let btnTypeClass = parentClasses.Button;
  switch (btnType) {
    case btnConfig.BTN_TYPE_SECONDARY:
      btnTypeClass = parentClasses.Secondary;
      break;
    case btnConfig.BTN_TYPE_BORDER:
      btnTypeClass = parentClasses.Border;
      break;
    case btnConfig.BTN_TYPE_TEXT:
      btnTypeClass = parentClasses.TextStyle + " ssssss ";
      break;
    case btnConfig.BTN_TYPE_SECONDARY_WHITE:
      btnTypeClass = parentClasses.SecondaryWhite;
      break;
    case btnConfig.BTN_TYPE_TRANSPARENT:
      btnTypeClass = parentClasses.Transparent;
      break;
    case btnConfig.BTN_TYPE_GRAY:
      btnTypeClass = parentClasses.Gray;
      break;
    default:
      break;
  }

  // Check the button size
  let btnSizeClass = "";
  switch (size) {
    case btnConfig.BTN_SIZE_SM:
      btnSizeClass = parentClasses.Sm;
      break;
    case btnConfig.BTN_SIZE_MD:
      btnSizeClass = parentClasses.Md;
      break;
    default:
      break;
  }

  const _alt = alt ? alt : title ? title : null;

  /**
   * Returing button
   */
  return (
    <button
      tabIndex={0}
      disabled={disable}
      className={`${btnTypeClass} ${btnSizeClass} ${_btnRoundedClass}  ${className}`}
      type={type}
      onClick={onClick}
      title={title ? title : null}
      alt={_alt}
    >
      {_text}
      {/* {_icon} */}
    </button>
  );
};

export default RoundedButton;
